// @ts-expect-error how does one type virtual module for typescript?
import commitHash from "virtual:commit-hash";

const CommitHash = () => {
  return <meta content={commitHash} name="commit-hash" />;
};

export { CommitHash };
